import React from 'react';
import { getCellStyle } from '../../utils/GIPlanningUtils';
import { getAdminBadge } from '../../utils/getAdminBadge';

const GIPlanningTable = ({
  data,
  columns,
  onCampaignClick,
  onColumnHeaderClick,
  isMobile = false,
  selectedCompany,
  selectedClient,
  displayMode,
  handleClientColumnClick,
  handleCompanyColumnClick,
  handleEntityColumnClick,
  handleCellClick,
  handleClientToggle,
  headerLabel = "Campagne",
  currentUser
}) => {
  const isAdmin = currentUser.isadmin || currentUser.issuperadmin;

  return <div className={`border border-gray-200 dark:border-gray-600 ${isMobile ? 'rounded-none border-l-0 border-r-0' : 'rounded-lg'} overflow-hidden`}>
    <div className="overflow-x-auto">
      <table className="min-w-full border-collapse">
        <thead className="bg-gray-50 dark:bg-gray-700">
          <tr>
            <th className="sticky left-0 top-0 z-30 bg-gray-50 dark:bg-gray-700 border-r border-b border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider w-64 md:w-96 min-w-64 md:min-w-96">
              {headerLabel}
            </th>
            {isAdmin && selectedCompany && displayMode === 'campaigns' && (
              <th className="sticky left-64 md:left-96 top-0 z-20 bg-gray-50 dark:bg-gray-700 border-r border-b border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider w-32 min-w-32">
                Client
              </th>
            )}
            {isAdmin && selectedClient && displayMode === 'campaigns' && (
              <th className="sticky left-64 md:left-96 top-0 z-20 bg-gray-50 dark:bg-gray-700 border-r border-b border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider w-32 min-w-32">
                Groupe
              </th>
            )}
            {isAdmin && selectedClient && displayMode === 'campaigns' && (
              <th className="sticky left-96 md:left-128 top-0 z-20 bg-gray-50 dark:bg-gray-700 border-r border-b border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider w-32 min-w-32">
                Entité
              </th>
            )}
            {columns.map(column => (
              <th key={column.key} className={`sticky top-0 z-10 border-r border-b border-gray-200 dark:border-gray-600 px-1 py-1 text-center text-xs font-medium uppercase tracking-wider w-12 ${
                column.isCurrent
                  ? 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200'
                  : 'bg-gray-50 dark:bg-gray-700 text-gray-500 dark:text-gray-300'
              }`}>
              {onColumnHeaderClick ? (
                <div className="cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
                     onClick={() => onColumnHeaderClick(column.key)}>
                  <div className="font-semibold">{column.label}</div>
                  {column.sublabel && (
                    <div className="text-[10px] text-gray-400 dark:text-gray-500">
                      {column.sublabel}
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className="font-semibold">{column.label}</div>
                  {column.isCurrent && (
                    <div className="text-[10px] text-blue-600 dark:text-blue-300 font-medium">
                      Aujourd'hui
                    </div>
                  )}
                  {column.sublabel && (
                    <div className="text-[10px] text-gray-400 dark:text-gray-500">
                      {column.sublabel}
                    </div>
                  )}
                </div>
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="bg-white dark:bg-gray-800">

        {data.map((row, index) => (
          <tr key={row.campaignId ? `campaign-${row.campaignId}` : `${row.isClientGroup ? 'client' : 'campaign'}-${row.campaign}-${index}`}
              className={`group hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-600 ${
                row.isClientGroup ? 'bg-blue-50 dark:bg-blue-950/20' : ''
              } ${
                row.isSubRow ? 'bg-gray-25 dark:bg-gray-750' : ''
              }`}>
            <td className={`sticky left-0 z-20 group-hover:bg-gray-50 dark:group-hover:bg-gray-700 border-r border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-sm w-64 md:w-96 min-w-64 md:min-w-96 ${
              row.isClientGroup ? 'bg-blue-50 dark:bg-blue-900' : 'bg-white dark:bg-gray-800'
            } ${
              row.isSubRow ? 'bg-gray-50 dark:bg-gray-700' : ''
            }`}>
              {row.isClientGroup ? (
                // Ligne de regroupement par client
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <button
                      onClick={() => handleClientToggle && handleClientToggle(row.client)}
                      className="mr-2 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 focus:outline-none"
                      title={row.isExpanded ? "Réduire" : "Développer"}
                    >
                      <svg className={`w-4 h-4 transform transition-transform ${row.isExpanded ? 'rotate-90' : ''}`}
                           fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                    <span className="font-semibold text-blue-800 dark:text-blue-200 truncate" title={row.client}>
                      {row.client}
                    </span>
                  </div>
                  <span className="text-xs text-blue-600 dark:text-blue-300 font-medium ml-2 flex-shrink-0">
                    {row.campaignCount} campagne{row.campaignCount > 1 ? 's' : ''} • {Object.values(row.data).reduce((sum, item) => sum + (item?.count || 0), 0)} total
                  </span>
                </div>
              ) : (
                // Ligne normale (campagne ou sous-campagne)
                <div className={`flex items-center ${row.isSubRow ? 'ml-6' : ''}`}>
                  {row.isSubRow && (
                    <div className="w-4 h-4 mr-2 flex items-center justify-center">
                      <div className="w-2 h-2 bg-gray-400 dark:bg-gray-500 rounded-full"></div>
                    </div>
                  )}
                  <div
                    className={displayMode === 'campaigns' && !row.isSubRow
                      ? "cursor-pointer hover:text-blue-600 hover:underline dark:text-gray-300 dark:hover:underline font-medium truncate"
                      : "dark:text-gray-300 font-medium truncate"
                    }
                    onClick={displayMode === 'campaigns' && !row.isSubRow ? () => onCampaignClick(row.campaign) : undefined}
                    title={row.campaign}
                  >
                    {(row.isActive === false && displayMode === 'campaigns') ? getAdminBadge() : ''}&nbsp;{row.campaign} <span className="text-gray-500 dark:text-gray-400 font-normal">({Object.values(row.data).reduce((sum, item) => sum + (item?.count || 0), 0)}) {(row.isActive === false && displayMode === 'campaigns') ? <span className="text-gray-500 dark:text-gray-400 font-normal">(Archivé)</span> : ''}</span>
                  </div>
                </div>
              )}
            </td>
            {isAdmin && selectedCompany && displayMode === 'campaigns' && !row.isClientGroup && (
              <td className={`sticky left-64 md:left-96 z-10 group-hover:bg-gray-50 dark:group-hover:bg-gray-700 border-r border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-sm w-32 min-w-32 ${
                row.isSubRow ? 'bg-gray-50 dark:bg-gray-700' : 'bg-white dark:bg-gray-800'
              }`}>
                <div
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-xs truncate cursor-pointer hover:underline font-medium"
                  title={`Cliquer pour basculer vers le client: ${row.client}`}
                  onClick={() => handleClientColumnClick(row.client)}
                >
                  {row.client}
                </div>
              </td>
            )}
            {isAdmin && selectedClient && displayMode === 'campaigns' && !row.isClientGroup && (
              <td className={`sticky left-64 md:left-96 z-10 group-hover:bg-gray-50 dark:group-hover:bg-gray-700 border-r border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-sm w-32 min-w-32 ${
                row.isSubRow ? 'bg-gray-50 dark:bg-gray-700' : 'bg-white dark:bg-gray-800'
              }`}>
                <div
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-xs truncate cursor-pointer hover:underline font-medium"
                  title={`Cliquer pour basculer vers la company: ${row.company}`}
                  onClick={() => handleCompanyColumnClick(row.company, row.companyId)}
                >
                  {row.company}
                </div>
              </td>
            )}
            {isAdmin && selectedClient && displayMode === 'campaigns' && !row.isClientGroup && (
              <td className={`sticky left-96 md:left-128 z-10 group-hover:bg-gray-50 dark:group-hover:bg-gray-700 border-r border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-sm w-32 min-w-32 ${
                row.isSubRow ? 'bg-gray-50 dark:bg-gray-700' : 'bg-white dark:bg-gray-800'
              }`}>
                {row.entity ? (
                  <div
                    className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-xs truncate cursor-pointer hover:underline font-medium"
                    title={`Cliquer pour basculer vers l'entité: ${row.entity}`}
                    onClick={() => handleEntityColumnClick(row.entity, row.entityId, row.company, row.companyId)}
                  >
                    {row.entity}
                  </div>
                ) : (
                  <div className="text-xs text-gray-400 dark:text-gray-500 truncate">
                    -
                  </div>
                )}
              </td>
            )}
            {/* Cellules vides pour les lignes de regroupement par client dans la colonne Client/Company */}
            {isAdmin && selectedCompany && displayMode === 'campaigns' && row.isClientGroup && (
              <td className="sticky left-64 md:left-96 z-10 bg-blue-50 dark:bg-blue-900 border-r border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-sm w-32 min-w-32">
              </td>
            )}
            {isAdmin && selectedClient && displayMode === 'campaigns' && row.isClientGroup && (
              <td className="sticky left-64 md:left-96 z-10 bg-blue-50 dark:bg-blue-900 border-r border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-sm w-32 min-w-32">
              </td>
            )}
            {isAdmin && selectedClient && displayMode === 'campaigns' && row.isClientGroup && (
              <td className="sticky left-96 md:left-128 z-10 bg-blue-50 dark:bg-blue-900 border-r border-gray-200 dark:border-gray-600 px-1 md:px-2 py-1 text-sm w-32 min-w-32">
              </td>
            )}
            {columns.map(column => (
              <td key={column.key} className={`border-r border-gray-200 dark:border-gray-600 px-1 py-1 text-center w-12 ${
                column.isCurrent ? 'bg-blue-50 dark:bg-blue-950' : ''
              }`}>
                {row.data[column.key] ? (
                  <div
                    className={`py-0.5 px-1 rounded text-xs font-medium ${
                      row.isClientGroup
                        ? '' // Pas de cursor-pointer pour les lignes agrégées multi-clients
                        : 'cursor-pointer hover:opacity-80'
                    } ${
                      column.isCurrent
                        ? 'bg-blue-200 dark:bg-blue-800 text-blue-900 dark:text-blue-100'
                        : (() => {
                            const states = row.data[column.key].states || {};
                            const statesMap = new Map(Object.entries(states));
                            const cellStyle = getCellStyle(statesMap);
                            return cellStyle.className;
                          })()
                    }`}
                    onClick={row.isClientGroup ? undefined : () => handleCellClick(row.campaign, column.key, 'campaign')}
                    title={row.isClientGroup ? undefined : "Cliquez pour voir les détails"}
                  >
                    {row.isClientGroup ? row.data[column.key].count : row.data[column.key].count}
                  </div>
                ) : (
                  <div className="text-gray-300 dark:text-gray-600">-</div>
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div>
};

export default GIPlanningTable;